<template>

  <div class="edit_sr_page">
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Editing Service Description - {{ bookingStringID }} - {{ activityTypeName }}
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <validation-observer
      ref="bookingServiceDescriptionEditForm"
    >
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col md="8">
            <div ref="service_description">
              <b-card
                v-show="customFields.length > 0"
                class="service-description-plain-card"
              >
                <div
                  v-for="(group, gIndex) in serviceDescriptionGroups"
                  :key="gIndex"
                  class="service-description-fields_group"
                >
                  <b-row
                    v-for="entry in group"
                    :key="entry.key"
                    :class="{ 'field-row-card': entry.opt.type !== 'title-and-text' }"
                  >
                    <b-col cols="12">
                      <div v-if="entry.opt.type == 'title-and-text'">
                        <p class="text-bold-black">
                          {{ entry.opt.label }}
                        </p>
                        <p v-if="serviceDescription[entry.key].text">
                          {{ serviceDescription[entry.key].text }}
                        </p>
                      </div>
                      <b-row
                        v-if="entry.opt.type == 'short-answer'"
                      >
                        <b-col md="12">
                          <div class="block_label">
                            <label
                              class="col-form-label"
                              :for="'event-custom-field-' + entry.key"
                            >{{ entry.opt.label }}</label>
                          </div>
                        </b-col>
                        <b-col md="10">
                          <validation-provider
                            #default="{ errors }"
                            :name="entry.opt.label"
                            :vid="'event-custom-field-' + entry.key"
                            :rules="entry.opt.required == 'yes' ? 'required' : ''"
                          >
                            <b-form-input
                              :id="'event-custom-field-' + entry.key"
                              v-model="serviceDescription[entry.key].value"
                              :placeholder="entry.opt.label"
                              :state="(errors.length > 0) ? false : null"
                              :readonly="!canViewThisAction('update', 'Booking')"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>

                      <b-row
                        v-if="entry.opt.type == 'long-answer'"
                      >
                        <b-col md="12">
                          <div class="block_label">
                            <label
                              class="col-form-label"
                              :for="'event-custom-field-' + entry.key"
                            >{{ entry.opt.label }}</label>
                          </div>
                        </b-col>
                        <b-col md="10">
                          <validation-provider
                            #default="{ errors }"
                            :name="entry.opt.label"
                            :vid="'event-custom-field-' + entry.key"
                            :rules="entry.opt.required == 'yes' ? 'required' : ''"
                          >
                            <b-form-textarea
                              :id="'event-custom-field-' + entry.key"
                              v-model="serviceDescription[entry.key].value"
                              trim
                              :placeholder="entry.opt.label"
                              :state="(errors.length > 0) ? false : null"
                              :readonly="!canViewThisAction('update', 'Booking')"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>

                      <div
                        v-if="entry.opt.type == 'increment'"
                        class="d-flex justify-content-between align-items-center field-row-inner"
                      >
                        <label
                          class="mb-0"
                          :for="'event-custom-field-' + entry.key"
                        >{{ entry.opt.label }}</label>
                        <validation-provider
                          #default="{ errors }"
                          :name="entry.opt.label"
                          :vid="'event-custom-field-' + entry.key"
                          :rules="entry.opt.required == 'yes' ? 'required' : ''"
                        >
                          <b-form-spinbutton
                            :id="'event-custom-field-' + entry.key"
                            v-model="serviceDescription[entry.key].value"
                            inline
                            class="spin-button-sd"
                            :state="(errors.length > 0) ? false : null"
                            :step="entry.opt.increments"
                            :min="entry.opt.minQuantity"
                            :max="entry.opt.maxQuantity"
                            :readonly="!canViewThisAction('update', 'Booking')"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>

                      <b-row
                        v-if="entry.opt.type == 'multi-select' && entry.opt.multiSelectType == 'multiple'"
                        :class="{ 'pointer-none': !canViewThisAction('update', 'Booking') }"
                      >
                        <b-col md="12">
                          <div class="block_label">
                            <label
                              class="col-form-label"
                              :for="'event-custom-field-' + entry.key"
                            >{{ entry.opt.label }}</label>
                          </div>
                        </b-col>
                        <b-col md="12">
                          <validation-provider
                            #default="{ errors }"
                            :name="entry.opt.label"
                            :rules="entry.opt.required == 'yes' ? 'required' : ''"
                          >

                            <b-form-checkbox-group
                              :id="'event-custom-field-' + entry.key"
                              v-model="serviceDescription[entry.key].value"
                              buttons
                              button-variant="outline-primary"
                              class="spaceBetweenRadio display-block-checkbox"
                            >
                              <b-form-checkbox
                                v-for="(optn, kindex) in entry.opt.extraOptions"
                                :key="kindex"
                                :value="optn.key"
                                class="mb-50 customCheckbox"
                              >
                                <feather-icon
                                  v-if="serviceDescription[entry.key].value.includes(optn.key)"
                                  icon="CheckIcon"
                                  class="mr-50"
                                  size="16"
                                />
                                <span class="align-middle">{{ optn.key }}</span>
                              </b-form-checkbox>
                            </b-form-checkbox-group>

                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>

                      <b-row
                        v-if="entry.opt.type == 'multi-select' && entry.opt.multiSelectType == 'single'"
                        :class="{ 'pointer-none': !canViewThisAction('update', 'Booking') }"
                      >
                        <b-col md="12">
                          <div class="block_label">
                            <label
                              class="col-form-label"
                              :for="'event-custom-field-' + entry.key"
                            >{{ entry.opt.label }}</label>
                          </div>
                        </b-col>
                        <b-col md="10">
                          <validation-provider
                            #default="{ errors }"
                            :name="entry.opt.label"
                            :rules="entry.opt.required == 'yes' ? 'required' : ''"
                          >
                            <b-form-checkbox-group
                              :id="'event-custom-field-' + entry.key"
                              v-model="serviceDescription[entry.key].value"
                              buttons
                              button-variant="outline-primary"
                              class="spaceBetweenRadio display-block-checkbox"
                              @input="makeCheckboxToRadio(entry.key)"
                            >
                              <b-form-checkbox
                                v-for="(optn, kindex) in entry.opt.extraOptions"
                                :key="kindex"
                                :value="optn.key"
                                class="mb-50 customCheckbox"
                              >
                                <feather-icon
                                  v-if="serviceDescription[entry.key].value.includes(optn.key)"
                                  icon="CheckIcon"
                                  class="mr-50"
                                  size="16"
                                />
                                <span class="align-middle">{{ optn.key }}</span>
                              </b-form-checkbox>
                            </b-form-checkbox-group>

                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>

                      <b-row
                        v-if="entry.opt.type == 'single-select'"
                      >
                        <b-col md="12">
                          <div class="block_label">
                            <label
                              class="col-form-label"
                              :for="'event-custom-field-' + entry.key"
                            >{{ entry.opt.label }}</label>
                          </div>
                        </b-col>
                        <b-col md="10">
                          <validation-provider
                            #default="{ errors }"
                            :name="entry.opt.label"
                            :rules="entry.opt.required == 'yes' ? 'required' : ''"
                          >

                            <b-form-checkbox-group
                              :id="'event-custom-field-' + entry.key"
                              v-model="serviceDescription[entry.key].value"
                              buttons
                              button-variant="outline-primary"
                              class="spaceBetweenRadio display-block-checkbox"
                              :disabled="!canViewThisAction('update', 'Booking')"
                              @input="makeCheckboxToRadio(entry.key)"
                            >
                              <b-form-checkbox
                                v-for="(optn, kindex) in requiredOptions"
                                :key="kindex"
                                :value="optn.value"
                                class="mb-50 customCheckbox"
                              >
                                <feather-icon
                                  v-if="serviceDescription[entry.key].value.includes(optn.value)"
                                  icon="CheckIcon"
                                  class="mr-50"
                                  size="16"
                                />
                                <span class="align-middle">{{ optn.text }}</span>
                              </b-form-checkbox>
                            </b-form-checkbox-group>

                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>

                      <validation-provider
                        v-if="entry.opt.type == 'dropdown'"
                        #default="{ errors }"
                        :name="entry.opt.label"
                        :vid="'event-custom-field-' + entry.key"
                        :rules="entry.opt.required == 'yes' ? 'required' : ''"
                      >
                        <b-row>
                          <b-col md="12">
                            <div class="block_label">
                              <label
                                class="col-form-label"
                                :for="'event-custom-field-' + entry.key"
                              >{{ entry.opt.label }}</label>
                            </div>
                          </b-col>
                          <b-col md="10">
                            <v-select
                              :id="'event-custom-field-' + entry.key"
                              v-model="serviceDescription[entry.key].value"
                              label="value"
                              placeholder="Select From List"
                              :options="entry.opt.extraOptions"
                              :reduce="value => value.key"
                              :clearable="true"
                              :disabled="!canViewThisAction('update', 'Booking')"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </b-col>
                        </b-row>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </div>
              </b-card>

              <b-card class="service-description-plain-card">
                <p class="text-bold-black mb-50">
                  Other Requests 其他需求
                </p>
                <b-form-textarea
                  id="booking-other-requests"
                  v-model="otherRequestsSR"
                  placeholder="Optional (for offering)"
                  rows="3"
                  :readonly="!canViewThisAction('update', 'Booking')"
                />
              </b-card>
            </div>
          </b-col>

          <b-col md="4">
            <b-card class="order-summary-card edit_sd">
              <h4 class="mb-1">
                Order Summary
              </h4>
              <div class="inner_wrapper">
                <div
                  v-if="orderSummaryDiff.added.length || orderSummaryDiff.removed.length"
                  class="added_sd_items"
                >
                  <div class="added_sd_items_inner">
                    <template v-if="orderSummaryDiff.added.length">
                      <div class="inner_group">
                        <p class="text-bold-black mb-50">
                          Added item(s)
                        </p>
                        <div
                          v-for="(item, index) in orderSummaryDiff.added"
                          :key="'added' + index"
                          class="d-flex justify-content-between mb-1"
                        >
                          <span class="qty_box">{{ item.qty }} x</span>
                          <span>{{ item.label }}</span>
                          <span class="text-success text-nowrap ml-1">+ {{ formatCurrency(item.amount) }}</span>
                        </div>
                      </div>
                    </template>

                    <template v-if="orderSummaryDiff.removed.length">
                      <div class="inner_group">
                        <p class="text-bold-black mb-50">
                          Removed item(s)
                        </p>
                        <div
                          v-for="(item, index) in orderSummaryDiff.removed"
                          :key="'removed' + index"
                          class="d-flex justify-content-between mb-1"
                        >
                          <span class="qty_box">{{ item.qty }} x</span>
                          <span>{{ item.label }}</span>
                          <span class="text-danger text-nowrap ml-1">– {{ formatCurrency(item.amount) }}</span>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="d-flex justify-content-between or_order_total">
                  <span>Original Order Total</span>
                  <span>{{ formatCurrency(originalOrderTotal) }}</span>
                </div>
                <div
                  v-if="additionalPaymentRequired !== 0"
                  class="d-flex justify-content-between font-weight-bold"
                >
                  <span>Updated Order Total</span>
                  <span>{{ formatCurrency(updatedOrderTotal) }}</span>
                </div>
                <div
                  v-else
                  class="d-flex justify-content-between empty_extra_item"
                >
                  <div class="inner_empty_box">
                    <div>No change to total</div>
                    <div>—</div>
                  </div>
                </div>

                <div
                  v-if="additionalPaymentRequired > 0"
                  class="order-summary-highlight-box mt-1 mb-1"
                >
                  <div class="summary_highlight_box_inner">
                    <p class="mb-0 text-bold-black">
                      Additional Payment Required
                    </p>
                    <h3 class="mb-0">
                      {{ formatCurrency(additionalPaymentRequired) }}
                    </h3>
                    <p class="text-muted mb-0">
                      {{ formatCurrency(originalOrderTotal) }} <span>→</span> {{ formatCurrency(updatedOrderTotal) }} • <small>Incl. 9% GST</small>
                    </p>
                  </div>
                </div>

                <div class="d-flex justify-content-between mt-1">
                  <span>Amount Paid</span>
                  <span>{{ formatCurrency(amountPaid) }}</span>
                </div>

                <div class="d-flex justify-content-between mt-2">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="button"
                    variant="flat-primary"
                    :to="{ name: 'appointment-bookings-show', params: { id: $route.params.id } }"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                  >
                    <span class="align-middle">Save & Update Order</span>
                  </b-button>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormInput, BForm, BButton, BFormTextarea,
  BFormCheckboxGroup, BFormCheckbox, BFormSpinbutton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required, min } from '@validations'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BForm,
    BButton,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSpinbutton,
    BFormTextarea,

    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      canViewThisAction,
      savedData: false,
      bookingStringID: '',
      activityTypeName: '',
      serviceDescription: [],
      customFields: [],
      tagProductOptions: [],
      serviceDescriptionSetId: null,
      previousValues: [],
      relatedOrder: null,
      otherRequestsSR: '',
      requiredOptions: [
        { text: 'Yes', value: 'yes' },
        { text: 'No', value: 'no' },
      ],

      // validation rules
      required,
      min,
    }
  },
  computed: {
    serviceDescriptionGroups() {
      const nodeMap = new Map()
      this.customFields.forEach((field, key) => {
        nodeMap.set(field.id, { opt: field, key, children: [] })
      })

      const roots = []
      this.customFields.forEach(field => {
        const node = nodeMap.get(field.id)
        const parentNode = field.parent && nodeMap.get(field.parent)
        if (parentNode) {
          parentNode.children.push(node)
        } else {
          roots.push(node)
        }
      })

      const flattenNode = (node, out) => {
        out.push({ opt: node.opt, key: node.key })
        node.children.forEach(child => flattenNode(child, out))
      }

      return roots.map(root => {
        const out = []
        flattenNode(root, out)
        return out
      })
    },
    originalOrderTotal() {
      return this.relatedOrder ? this.relatedOrder.total : 0
    },
    amountPaid() {
      return this.relatedOrder ? this.relatedOrder.amountPaid : 0
    },
    orderSummaryDiff() {
      const added = []
      const removed = []

      this.serviceDescription.forEach(current => {
        const previous = this.previousValues.find(o => o.id === current.id) || this.previousValues.find(o => o.key === current.key)
        const field = this.customFields.find(f => f.id === current.id)

        if (current.type === 'increment') {
          const newQty = Number(current.value) || 0
          const oldQty = previous ? Number(previous.value) || 0 : 0
          const price = this.resolveFieldPrice(field, current.key)
          if (newQty > oldQty) {
            added.push({
              qty: newQty - oldQty, label: current.key, amount: price * (newQty - oldQty),
            })
          } else if (newQty < oldQty) {
            removed.push({
              qty: oldQty - newQty, label: current.key, amount: price * (oldQty - newQty),
            })
          }
        } else if (current.type === 'multi-select' || current.type === 'single-select') {
          const newVals = Array.isArray(current.value) ? current.value : []
          const oldRaw = previous ? previous.value : []
          let oldVals = []
          if (Array.isArray(oldRaw)) {
            oldVals = oldRaw
          } else if (oldRaw) {
            oldVals = [oldRaw]
          }

          newVals.filter(v => !oldVals.includes(v)).forEach(v => {
            added.push({ qty: 1, label: v, amount: this.resolveFieldPrice(field, v) })
          })
          oldVals.filter(v => !newVals.includes(v)).forEach(v => {
            removed.push({ qty: 1, label: v, amount: this.resolveFieldPrice(field, v) })
          })
        }
      })

      return { added, removed }
    },
    updatedOrderTotal() {
      const addedTotal = this.orderSummaryDiff.added.reduce((sum, item) => sum + item.amount, 0)
      const removedTotal = this.orderSummaryDiff.removed.reduce((sum, item) => sum + item.amount, 0)
      return this.originalOrderTotal + addedTotal - removedTotal
    },
    additionalPaymentRequired() {
      return this.updatedOrderTotal - this.originalOrderTotal
    },
  },
  async beforeMount() {
    this.$http.get('products/retail-items/respond-with/name-and-id')
      .then(response => {
        this.tagProductOptions = response.data.stores || []
      })
      .catch(() => {})

    await this.$http.get(`appointment/bookings/${this.$route.params.id}/show`)
      .then(response => {
        const booking = response.data.data || {}
        this.bookingStringID = booking.stringID || ''
        this.activityTypeName = booking.activityType ? booking.activityType.typeName : ''
        this.previousValues = booking.serviceDescription || []
        this.otherRequestsSR = (booking.retailOrder && booking.retailOrder.orderRemarks) || ''
        this.serviceDescriptionSetId = booking.serviceDescriptionSet || null

        document.title = `Editing ${booking.stringID} | ${process.env.VUE_APP_APP_NAME || 'Nirvana Memorial Garden'}`
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })

    this.relatedOrder = await this.findRelatedOrder()

    // Bookings made before serviceDescription was persisted on the Booking itself (or
    // any booking whose order predates this field) have no previousValues to seed the
    // form from - so anything actually already in the linked order won't show as
    // selected unless we reconstruct it here from the order's own line items, matched
    // back to the catalog by name (the exact same string the order item was created
    // from - see computeActivityOrderTotal/buildServiceDescriptionFromItems).
    const orderItemsByName = {}
    const orderItems = (this.relatedOrder && this.relatedOrder.items) || []
    orderItems.forEach(item => {
      orderItemsByName[item.name] = item
    })

    // Prefer the exact ServiceDescriptionSet this booking was created from (operations/
    // service-description-setups) over the legacy global ServiceDescription doc, so
    // editing shows the same fields the customer actually filled in.
    let sourceCustomFields = []
    try {
      if (this.serviceDescriptionSetId) {
        const setResponse = await this.$http.get(`operation/service-description-setups/${this.serviceDescriptionSetId}/show`)
        sourceCustomFields = (setResponse.data.data && setResponse.data.data.items) || []
      } else {
        const catalogResponse = await this.$http.get('appointment/bookings/respond-with/service-description-catalog')
        const { serviceDescription } = catalogResponse.data
        sourceCustomFields = (serviceDescription && serviceDescription.customFields) || []
      }
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    }

    // The two sources shape Quantity fields differently: the legacy editor stores
    // min/max/step as extraOptions[0/1/2], the ServiceDescriptionSet builder stores
    // them as top-level minQuantity/maxQuantity/increments. Normalize once here so
    // the rest of this component (and the template) only deals with one shape.
    const normalizedFields = sourceCustomFields.map(field => {
      if (field.type !== 'increment' || (field.minQuantity !== undefined && field.minQuantity !== null)) {
        return field
      }
      const opts = field.extraOptions || []
      return {
        ...field,
        minQuantity: opts[0] ? opts[0].value : 0,
        maxQuantity: opts[1] ? opts[1].value : 0,
        increments: opts[2] ? opts[2].value : 1,
      }
    })

    if (normalizedFields.length) {
      this.serviceDescription = normalizedFields.map(arrayItem => this.buildServiceDescriptionValue(arrayItem, orderItemsByName))
    }
    this.customFields = normalizedFields
  },
  beforeRouteLeave(to, from, next) {
    if (!this.savedData) {
      this.$swal({
        title: 'Unsaved Changes - Leave?',
        html: 'You have unsaved changes. Are you sure you want to leave this page?',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: "Yes, I'm Sure",
        cancelButtonText: 'No, Go Back',
        customClass: {
          confirmButton: 'btn btn-outline-primary no-focus-bg ml-1',
          cancelButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            next()
          } else {
            next(false)
          }
        })
    } else {
      next()
    }
  },
  methods: {
    // Builds one serviceDescription value entry for a field definition, preferring the
    // booking's own previously-submitted value (matched by id, falling back to label),
    // then falling back to reconstructing it from the linked order's line items (for
    // bookings that predate serviceDescription being persisted), over the field's default.
    buildServiceDescriptionValue(arrayItem, orderItemsByName) {
      const newObj = {}
      newObj.key = arrayItem.label
      newObj.type = arrayItem.type
      newObj.id = arrayItem.id
      newObj.parent = arrayItem.parent
      const exist = this.previousValues.find(o => o.id === arrayItem.id)
      const old = this.previousValues.find(o => o.key === arrayItem.label)
      const source = exist || old
      if (source) {
        if (arrayItem.type === 'multi-select' || arrayItem.type === 'single-select') {
          newObj.value = Array.isArray(source.value) ? (source.value || []) : ([source.value] || [])
        } else if (arrayItem.type === 'title-and-text') {
          newObj.value = ''
          newObj.text = arrayItem.description
        } else if (arrayItem.type === 'increment') {
          newObj.value = +source.value
        } else {
          newObj.value = source.value || ''
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (arrayItem.type === 'multi-select' || arrayItem.type === 'single-select') {
          const matchedOption = (arrayItem.extraOptions || []).find(optn => orderItemsByName[optn.value])
          newObj.value = matchedOption ? [matchedOption.key] : []
        } else if (arrayItem.type === 'title-and-text') {
          newObj.value = ''
          newObj.text = arrayItem.description
        } else if (arrayItem.type === 'increment') {
          const matchedItem = orderItemsByName[arrayItem.baseLabel || arrayItem.label]
          newObj.value = matchedItem ? matchedItem.quantity : +arrayItem.minQuantity
        } else {
          newObj.value = ''
        }

        // Seed previousValues too, so the Order Summary diff treats this
        // reconstructed selection as the starting point, not a fresh "Added" item.
        const hasValue = (Array.isArray(newObj.value) && newObj.value.length)
          || (arrayItem.type === 'increment' && newObj.value > 0)
        if (hasValue) {
          this.previousValues.push({
            id: newObj.id, key: newObj.key, type: newObj.type, value: newObj.value,
          })
        }
      }
      return newObj
    },
    extractPrice(label) {
      const match = String(label).match(/S?\$\s?([\d,]+(?:\.\d+)?)/)
      return match ? parseFloat(match[1].replace(/,/g, '')) : 0
    },
    // Prefers the real price of the field's (or, for multi-select/dropdown, the selected
    // option's) tagged Catalog Product and falls back to parsing a "$xx" amount out of the
    // legacy label text - mirrors resolveLinePrices() in the backend's retail-order-payment
    // helper, which is the actual source of truth for what gets charged.
    resolveFieldPrice(field, value) {
      let tagProduct = null
      if (field) {
        if (field.type === 'increment') {
          tagProduct = field.tagProduct
        } else if (field.type === 'single-select') {
          tagProduct = value === 'yes' ? field.tagProduct : null
        } else if (field.type === 'multi-select' || field.type === 'dropdown') {
          const matchedOption = (field.extraOptions || []).find(o => o.key === value)
          tagProduct = matchedOption ? matchedOption.tagProduct : null
        }
      }
      if (tagProduct) {
        const product = this.tagProductOptions.find(o => o._id === tagProduct)
        if (product && product.unitPrice !== undefined && product.unitPrice !== null) return product.unitPrice
      }
      return this.extractPrice(value)
    },
    formatCurrency(amount) {
      return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    },
    findRelatedOrder() {
      return this.$http.get('sales/retail-orders', { params: { relatedBooking: this.$route.params.id, perPage: 1 } })
        .then(response => (response.data.retailOrders || [])[0] || null)
        .catch(() => null)
    },
    redirectToRelatedOrder() {
      this.findRelatedOrder()
        .then(relatedOrder => {
          if (relatedOrder) {
            this.$router.push({
              name: 'customers-orders-show',
              params: { id: relatedOrder._id },
              query: { updated: '1' },
            })
          } else {
            this.$router.push({ name: 'appointment-bookings-show', params: { id: this.$route.params.id } })
          }
        })
    },
    makeCheckboxToRadio(key) {
      const lastSelected = this.serviceDescription[key].value.slice(-1)[0]
      if (lastSelected) {
        this.serviceDescription[key].value = this.serviceDescription[key].value.filter(code => code === lastSelected)
      }
    },
    submitForm() {
      this.$refs.bookingServiceDescriptionEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('serviceDescription', JSON.stringify(this.serviceDescription))
          formData.append('otherRequestsSR', this.otherRequestsSR)

          this.$http.patch(`appointment/bookings/${this.$route.params.id}/service-description/update`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(response => {
              if (response.data.data) {
                this.$swal({
                  title: 'Order has been updated',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/success.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  width: 400,
                  showCancelButton: false,
                  showConfirmButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
                  .then(() => {
                    this.savedData = true
                    this.redirectToRelatedOrder()
                  })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: response.data.message || '',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
        } else {
          const items = document.getElementsByClassName('is-invalid')
          if (items && items.length) {
            items[0].scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            })
          }
        }
      })
    },
  },
}
</script>
